module.exports = __webpack_public_path__ + "static/media/instagram-light.90dc2a95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/instagram-light.svg
// module id = 433
// module chunks = 0